import { Component, OnInit } from '@angular/core';
import {  Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination-limit',
  templateUrl: './pagination-limit.component.html',
  styleUrls: ['./pagination-limit.component.scss']
})
export class PaginationLimitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Input() currentPageLimit: number = 1;
  @Input() totalPageLimits: number[] = [5,10,20];

  @Output() pageLimitChange = new EventEmitter<number>();

  changePage(page: number): void {
    if (page !== this.currentPageLimit) {
      this.pageLimitChange.emit(page);
    }
  }
}
